module.exports = __webpack_public_path__ + "files/89ee8d762a7707a497e87c4a2ce8427b.png";